export default __webpack_public_path__ + "static/media/guttasmart.b9d6aaab.png";